import { render, staticRenderFns } from "./PortfolioReportStatic.vue?vue&type=template&id=db60785a&scoped=true&"
import script from "./PortfolioReportStatic.vue?vue&type=script&lang=js&"
export * from "./PortfolioReportStatic.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioReportStatic.vue?vue&type=style&index=0&id=db60785a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db60785a",
  null
  
)

export default component.exports